import axios from 'axios';
import { AsyncAction } from '..';
import { ReferenceDocument } from '../../types/asset';

type State = {
    fetching: boolean;
    items: ReferenceDocument[];
    error?: Error;
};

type Action = {
    type: 'plan_referenceDocuments/get';
    payload?: { items: ReferenceDocument[] };
    error?: Error;
};

const initialState: State = {
    fetching: false,
    items: [],
};

export const filterValidReferenceDocuments = (referenceDocuments: ReferenceDocument[]): ReferenceDocument[] => {
    const validDocIds = [11, 12];
    return referenceDocuments.filter(doc => validDocIds.includes(doc.id));
};

export const reducer = (state = initialState, action: Action): State => {
    switch (action.type) {
        case 'plan_referenceDocuments/get':
            if (action.payload) return { ...state, fetching: false, ...action.payload };
            if (action.error) return { ...state, fetching: false, error: action.error };
            return { ...state, fetching: true };
        default:
            return state;
    }
};

/**
 * Request all asset reference documents from the server.
 * If there are reference documents already fetched, the request is ignored.
 *
  @param rethrow throw the internal error, causing the promise generated by the dispatch to fail
 */
const get = (rethrow = false): AsyncAction => async dispatch => {
    try {
        dispatch({ type: 'plan_referenceDocuments/get' });
        const cancel = axios.CancelToken.source();
        dispatch({ type: 'cancel/set', payload: { 'plan_referenceDocuments/get': cancel } });
        const response = await axios.get<ReferenceDocument[]>('/reference-documents/', {
            cancelToken: cancel.token,
        });
        const filteredReferences = filterValidReferenceDocuments(response.data);
        dispatch({ type: 'plan_referenceDocuments/get', payload: { items: filteredReferences } });
    } catch (error) {
        if (error.name === 'AbortError') return;
        dispatch({ type: 'plan_referenceDocuments/get', error });
        if (rethrow) throw error;
    }
};

export const creators = { get };
